import { GzPageNavigationHeaderWebComponent } from './component/GzPageNavigationHeaderWebComponent';

export { GzPageNavigationHeaderWebComponent };
